import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { MappingTemplate } from '../../../data/types/mapping-template';
import { messages } from './messages';
import styles from './styles.module.css';

export const MappingTemplateStandardRow = ({ importTemplate, openModal, onStartEdit }) => (
  <tr>
    <td className={styles['name-cell']}>{importTemplate.name}</td>
    <td className={styles['actions-cell']}>
      <Button onClick={onStartEdit} theme='link'>
        <FormattedMessage {...messages.templateRowEditButton} />
      </Button>
      <span className={styles.separator}>|</span>
      <Button onClick={openModal} theme='link'>
        <FormattedMessage {...messages.templateRowDeleteButton} />
      </Button>
    </td>
  </tr>
);

MappingTemplateStandardRow.propTypes = {
  importTemplate: MappingTemplate.isRequired,
  openModal: PropTypes.func.isRequired,
  onStartEdit: PropTypes.func.isRequired,
};
